import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadProfile, updateProfile } from "./profile-actions.js";
import { profileService } from "../service/profile-service.js";

export const loadProfileEffect = actions$.pipe(
  ofType(loadProfile.action),
  switchMap(() =>
    profileService.loadProfile().pipe(
      map((data) => loadProfile.success(data)),
      catchError((err) => of(loadProfile.fail(err))),
    ),
  ),
);

export const updateProfileEffect = actions$.pipe(
  ofType(updateProfile.action),
  switchMap((action) =>
    profileService.updateProfile(action.payload).pipe(
      map((data) => updateProfile.success(data)),
      catchError((err) => of(updateProfile.fail(err))),
    ),
  ),
);

export const profileEffects = [loadProfileEffect, updateProfileEffect];
